<template>
	<div class="breath-theme">
		<section class="breath-theme__aside">
			<div class="breath-theme__header">
				  <el-select v-model="types_list_query.campaignId" filterable remote placeholder="主题分类" 
				   style="width: 180px;" size="small"
				   :remote-method="remoteMeTypesthod"
				   @change="onChange"
				   clearable
				   :loading="select_loading">
				     <el-option
				       v-for="item in campaignIdOptions"
				       :key="item.campaignId"
				       :label="item.campaignName"
				       :value="item.campaignId">
				     </el-option>
				   </el-select>
				  <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增分类</el-button>
			</div>
			<div class="lists">
				<h1>分类列表</h1>
				<ul>
					<li v-for="(item,index) in types_lists" :key="index" :class="{'active':types_active == index}" @click.stop="onTypesClick(index,item)">
						<el-input v-if="item.editable" v-model="item.campaignName" placeholder="请输入分类名称" size="mini" style="width: 180px;" :maxlength="30" show-word-limit></el-input>
						<span v-else>{{item.campaignName}}</span>
						<span v-show="types_active == index" @click.stop>
							<i class="el-icon-edit" style="color: #337EFF;"  v-show="!item.editable" @click.stop="onTypesEdit(item)"></i>
							<el-popconfirm title="确定删除该主题分类？"  icon-color="red"  icon="el-icon-info" @confirm="onTypesDelete(item,index)">
								<i class="el-icon-delete" style="color: #f56c6c;margin:0 10px;"  slot="reference"></i>
							</el-popconfirm>
							<i class="el-icon-check" style="color: #337EFF;" v-show="item.editable" @click.stop="onTypesSave(item)"></i>
						</span>
					</li>
					<li>
						<el-button type="text" @click="toMoreTypelists" :loading="more_loading" :disabled="types_list_query.pageNumber >= types_pages">
							{{types_list_query.pageNumber < types_pages ? '加载更多' : ''}}
						</el-button>
					</li>
				</ul>
			</div>
		</section>
		<section class="basis-page-cls breath-theme__main">
			<!-- <div class="basis-cls_filter">
				<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch"/>
			</div> -->
			<table-search-index :defaultQuery="listQuery" :filterHeader="filterHeader" @filterSearch="filterSearch" @filterSelectRemote="filterSelectRemote"/>
			<div class="table-lists">
				<div class="table-lists__header">
					 <h1>数据列表</h1>
					 <el-button @click.stop="handleThemeCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增主题</el-button>
				</div>
				<div class="table-lists__box">
					<table-pagination
						v-loading="theme_loading"
					    pagination
					    :data="theme_lists"
					    :column="theme_column"
					    :total="theme_total"
					    :page.sync="listQuery.pageNumber"
					    :limit.sync="listQuery.pageSize"
					    @pagination="getThemesLists" />
				</div>
			</div>
		</section>
		<!-- 新增、修改主题 -->
		<CreateTheme ref="createTheme" @getThemesLists="getThemesLists"/>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import CreateTheme from './createTheme.vue';
	import { filterHeaderSearch } from '@/utils/mixins'
	export default {
		mixins:[filterHeaderSearch],
		components:{
			CreateTheme
		},
		computed: {
			...mapGetters([
				'userInfo',  
				'subBrandList'
			]),
		},
		data(){
			return {
				filterHeader:[
					{label: '子品牌', model: 'childBrandIdentify', type: 'select', default: '', list: []},
					{label: '外呼主题', model: 'subjectId', type: 'select', default: '', list: [], loading:false,isRemote:true, labelName:'subjectName',valueName:'subjectId'},
					{label: '状态', model: 'subjectStatus', type: 'select', default: '', list: [
						{id: '2', name: '已启用'},
						{id: '1', name: '待启用'}
					]},
				],
				listQuery:{
					brandIdentify:'',
					childBrandIdentify:'',
					subjectId:'',
					campaignId:'',
					subjectStatus:'',
					pageSize:10,
					pageNumber:1,
				},
				theme_lists:[],
				theme_column:[
					{
					    label: '序号',
					    width: 80,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},
					{ label: '外呼主题', prop: 'subjectName' },
					{ label: '开始时间', prop: 'startTime' },
					{ label: '截止时间', prop: 'endTime' },
					{ 
						label: '状态', 
						prop: 'subjectStatus',
						render: (h, scope) => {
						    return <el-tag type={scope.row.subjectStatus == '2' ? 'success' : 'info'} size="small">{scope.row.subjectStatus == '2' ? '已启用' : '待启用'}</el-tag>
						}
					},
					{ label: '备注', prop: 'subjectRemarks' },
					{ label: '外呼数据文件', prop: 'originalBatchRemarks' },
					{ label: '问卷', prop: 'surveyName' },
					{
					    label: '操作',
					    prop: 'cation',
					    align: 'center',
					    width: 230,
					    fixed: 'right',
					    render: (h, scope) => {
							return (
								<div>
									<el-link onClick={() => this.toCreateTask(scope.row)} underline={false} type="primary">生成任务</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.onThemeEdit(scope.row)} underline={false} type="primary">修改</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.onThemeCopy(scope.row)} underline={false} type="primary">复制</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.onThemeDelete(scope.row)} underline={false} type="danger" disabled={scope.row.subjectStatus == 2}>删除</el-link>
								</div>
							)
					    }
					}
				],
				theme_total:1,
				campaignIdOptions:[],
				select_loading:false,
				types_lists:[],//分类列表
				types_list_query:{
					campaignId:'',
					campaignName:'',
					brandIdentify:'',
					pageNumber:1,
					pageSize:10
				},
				types_active:0,
				types_pages:1,//总页数
				loading:false,
				theme_loading:false,
				more_loading:false
				
			}
		},
		methods: {
			filterSearch() {
				this.theme_loading = true;
				this.getThemesLists()
			},
			resetFilter(){
				this.filterHeader.map(item => {
					this.listQuery[item.model] = item.default;
				})
			},
			//复制主题
			onThemeCopy(row){
					this.$confirm('确认复制该主题, 是否继续?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.copyBreathThemeItem({
						subjectId: row.subjectId
					}).then(response => {
						if(response.errcode != 0) return;
						 this.$notify({
							title: "复制成功",
							type: "success"
						});
						this.getThemesLists()
					});
				}).catch(() => {});
			},
			// 新增分类
			handleCreate(){
				let index = this.types_lists.findIndex(el => el.editable);
				if(index != -1) return this.$message.error('列表中有未保存的数据，请先保存');
				this.types_lists.push({
					campaignName:'默认分类',
					editable:true
				})
			},
			// 编辑分类
			onTypesEdit(row){
				this.$set(row,'editable',true);
			},
			// 删除分类
			onTypesDelete(row,index){
				if(!row.campaignId){
					this.types_lists.splice(index,1);
					return;
				}
				this.$api.deleteBreathThemeTypesList({
					brandIdentify:this.types_list_query.brandIdentify,
					campaignId:row.campaignId
				}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success({
					  message: '删除分类成功',
					  position: 'top-left'
					});
					this.types_active = this.types_active - 1 < 0 ? 0 : this.types_active - 1;
					this.getTypesLists();
					
				})
			},
			// 下拉分类搜索
			remoteMeTypesthod(query){
				this.select_loading = true;
				this.types_list_query.campaignName = query;
				this.types_list_query.brandIdentify = this.userInfo.brandIdentify;
				this.$api.getBreathThemeTypesList(this.types_list_query).then(res => {
					this.select_loading = false;
					if(res.errcode != 0) return;
					this.campaignIdOptions = res.data;
				})
			},
			onChange(){
				this.getTypesLists()
			},
			onTypesClick(index,row){
				this.types_active = index;
				this.listQuery.campaignId = row.campaignId;
				this.theme_loading = true;
				this.theme_lists = [];
				this.getThemesLists()
			},
			onTypesSave(row){
				if(row.campaignId){
					this.$api.editBreathThemeTypesList({
						brandIdentify:this.types_list_query.brandIdentify,
						campaignName:row.campaignName,
						campaignId:row.campaignId
					}).then(res => {
						if(res.errcode !=0) return;
						this.$notify.success({
						  message: '修改分类成功',
						  position: 'top-left'
						});
						this.$set(row,'editable',false);
						this.getTypesLists();
					})
				}else {
					this.$api.addBreathThemeTypesList({
						brandIdentify:this.types_list_query.brandIdentify,
						campaignName:row.campaignName
					}).then(res => {
						if(res.errcode !=0) return;
						this.$notify.success({
						  message: '新增分类成功',
						  position: 'top-left'
						});
						this.$set(row,'editable',false);
						this.getTypesLists()
					})
				}
				
			},
			toMoreTypelists(){
				if(this.types_list_query.pageNumber < this.types_pages) {
					this.types_list_query.pageNumber++;
					this.getTypesLists('more');
				}
			},
			async getTypesLists(type){
				this.more_loading = true;
				this.types_list_query.brandIdentify = this.userInfo.brandIdentify;
				await this.$api.getBreathThemeTypesList(this.types_list_query).then(res => {
					this.more_loading = false;
					if(res.errcode != 0) return;
					this.types_lists = type ? this.types_lists.concat(res.data) : res.data;
					this.types_pages = res.pages;
					this.listQuery.campaignId = res.data.length > 0 ? res.data[this.types_active].campaignId : ''
					if(!type) {
						this.getThemesLists()
					}
				}).catch((err) => {
					this.more_loading = false;
				})
			},
			async getThemesLists(){
				if(!this.listQuery.campaignId){
					this.theme_loading = false;
					this.theme_lists = [];
					this.theme_total = 0;
					return;
				}
				this.listQuery.brandIdentify = this.userInfo.brandIdentify;
				await this.$api.getBreathThemeList(this.listQuery).then(res => {
					this.theme_loading = false;
					if(res.errcode != 0) return;
					this.theme_lists = res.data;
					this.theme_total = Number(res.total);
				})
			},
			// 新增主题
			handleThemeCreate(){
				if(this.types_lists.length == 0) return this.$message.error('请先新增分类');
				this.$refs.createTheme.onShow(this.types_lists[this.types_active],'add')
			},
			onThemeEdit(row){
				this.$refs.createTheme.onShow(row,'edit')
			},
			onThemeDelete(row){
				this.$confirm('删除后将无法恢复, 是否继续?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteBreathThemeList({
						brandIdentify: row.brandIdentify,
						subjectId: row.subjectId
					}).then(response => {
						if(response.errcode != 0) return;
						 this.$notify({
							title: "删除成功",
							type: "success"
						});
						this.getThemesLists()
					});
				}).catch(() => {});
			},
			toCreateTask(row){
				this.$refs.createTheme.onShow(row,'task')
			}
		},
		async created(){
			this.filterHeader[0].list = await this.subBrandList;
			this.listQuery.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
			await this.getTypesLists();
		}
	}
</script>

<style lang="scss" scoped>
	.breath-theme {
		display: flex;
		height: 100%;
		background: #FFF;
		box-sizing: border-box;
		color: #3c4353;
		&__aside {
			width: 300px;
			padding: 10px;
			.lists {
				height: calc(100% - 30px);
				box-sizing: border-box;
				overflow: hidden;
				h1 {
					font-size: 14px;
					color: #337eff;
					font-weight: 500;
					margin: 10px 0;
					
				}
				> ul {
					height: calc(100% - 50px);
					overflow-y: auto;
					margin-top: 10px;
					font-size: 14px;
					color: #3c4353;
					li {
						line-height: 30px;
						padding: 0 10px;
						cursor: pointer;
						border-radius: 3px;
						display: flex;
						justify-content: space-between;
						&.active {
							background-color:#edf5ff ;
						}
					}
				}
				
			}
		}
		&__main {
			width: calc(100% - 300px);
			border-left: 1px solid #dcdfe6;
			padding: 10px;
			.table-lists {
				padding-top: 10px;
				&__box {
					margin-top: 10px;
				}
			}
			.table-lists__header {
				display: flex;
				justify-content: space-between;
				h1 {
					font-size: 14px;
					font-weight: 500;
				}
			}
		}
	}
</style>
